import {useEffect, useRef, useState} from "react";
import axios from "axios";
import {useParams} from "react-router-dom";
import {useDownloadExcel} from "react-export-table-to-excel";
import * as FileSaver from "file-saver";

const people = [
    {name: 'Lindsay Walton', title: 'Front-end Developer', email: 'lindsay.walton@example.com', role: 'Member'},
    // More people...
]

export default function Pronostics() {
    const [loading, setLoading] = useState(true);
    const [pronostics, setPronostics] = useState([]);

    let {id} = useParams();

    const tableRef = useRef(null);

    const onDownload = async () => {
        const response = await axios({
            baseURL: `${process.env.REACT_APP_API_URL}/pronos/export-to-excel`,
            method: "get",
            responseType: "blob",
            params: {
                matchId: id,
            },
        });

        const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        FileSaver.saveAs(blob, `pronostics-${id}.xlsx`);
    }

    const fetchAllPronos = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/pronos/${id}`).then((resp) => {
            setLoading(false);
            setPronostics(resp.data)
        }).catch((err) => {
            alert(err)
        })
    };

    useEffect(() => {
        fetchAllPronos();
    }, []);
    return (
        <div>
            {
                loading ?
                    <div className={"flex flex-col items-center my-10"}>
                        <div
                            className="relative items-center block max-w-full p-6 bg-white border border-gray-100 rounded-lg shadow-md ">
                            <h5 className="mb-2 text-2xl font-bold tracking-tight text-black opacity-50">Récupération de
                                la liste des matchs</h5>
                            <div role="status" className="absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2">
                                <svg aria-hidden="true"
                                     className="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-pink-600"
                                     viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                        fill="currentColor"/>
                                    <path
                                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                        fill="currentFill"/>
                                </svg>
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div> :
                    <div className="p-16 sm:px-6 lg:px-8">
                        <div className="sm:flex sm:items-center">
                            <div className="sm:flex-auto">
                                <h1 className="text-base font-semibold leading-6 text-gray-900">Pronostics</h1>
                                <p className="mt-2 text-sm text-gray-700">
                                    A list of all the pronostics of the selected match
                                </p>
                            </div>
                            <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
                                <button onClick={onDownload}
                                        type="button"
                                        className="block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                >
                                    Exporter
                                </button>
                            </div>
                        </div>
                        <div className="mt-8 flow-root">
                            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                                    <table className="min-w-full divide-y divide-gray-300" ref={tableRef}>
                                        <thead>
                                        <tr>
                                            <th scope="col"
                                                className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                                                Username
                                            </th>
                                            <th scope="col"
                                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                Phone
                                            </th>
                                            <th scope="col"
                                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                Equipe 1
                                            </th>
                                            <th scope="col"
                                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                Equipe 2
                                            </th>
                                            <th scope="col"
                                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                Premier Essaie
                                            </th>
                                            <th scope="col"
                                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                Pénalités
                                            </th>
                                            <th scope="col"
                                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                Transformations
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200">
                                        {pronostics.map((prono) => (
                                            <tr key={prono.id}>
                                                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                                                    {prono.username}
                                                </td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{prono.email_or_phone}</td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{prono.score_1}</td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{prono.score_2}</td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{prono.first_try}</td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{prono.number_of_penalities}</td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{prono.number_of_transformation}</td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

            }
        </div>
    )
}
